import axiosInstance from './axios';

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface AuthCompany {
    id: string;
    nombre: string;
    nit: string;
    direccion?: string;
    telefono?: string;
    email?: string;
    status: 'ACTIVA' | 'INACTIVA' | 'PRUEBA';
    billingEnabled: boolean;
    capacidadCarros: number;
    capacidadMotos: number;
    expensesEnabled: boolean;
    expensesOperatorAllowed: boolean;
    expensesLinkedToCashbox: boolean;
    shiftAuthRule: 'SIEMPRE' | 'SOLO_CIERRE' | 'SOLO_ABRIR' | 'SOLO_DESCUADRE' | 'NUNCA';
    storeEnabled?: boolean;
    storeOperatorAllowed?: boolean;
    maxSedes?: number;
}

export interface UserSede {
    id: string;
    nombre: string;
    direccion?: string | null;
}

export interface User {
    id: string;
    email: string;
    nombre: string;
    rol: 'SUPERADMIN' | 'ADMIN' | 'OPERADOR';
    telefono?: string;
    companyId?: string;
    company?: AuthCompany;
    /** Sede asignada (OPERADOR) o la única de la empresa */
    sedeId?: string | null;
    /** Sedes a las que el usuario tiene acceso */
    sedes?: UserSede[];
}

export interface LoginResponse {
    user: User;
}

/**
 * Iniciar sesión con email y contraseña
 * El token JWT se envía automáticamente en una cookie HttpOnly
 */
export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await axiosInstance.post<LoginResponse>('/auth/login', credentials);
    return response.data;
};

/**
 * Obtener datos del usuario autenticado
 */
export const getMe = async (): Promise<User> => {
    const response = await axiosInstance.get<User>('/auth/me');
    return response.data;
};

/**
 * Validar credenciales de administrador
 */
export const validateAdmin = async (credentials: LoginCredentials) => {
    const { data } = await axiosInstance.post('/auth/validate-admin', credentials);
    return data;
};

/**
 * Cerrar sesión - llama al backend para limpiar la cookie
 */
export const logout = async (): Promise<void> => {
    try {
        await axiosInstance.post('/auth/logout');
    } catch {
        // Si falla, no es crítico
    }
    // Limpiar datos locales de compatibilidad
    localStorage.removeItem('userRole');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('empresaId');
    localStorage.removeItem('empresaNombre');
    localStorage.removeItem('sedeId');
};

/**
 * Solicitar recuperación de contraseña
 */
export const forgotPassword = async (email: string) => {
    const response = await axiosInstance.post<{ message: string }>('/auth/forgot-password', { email });
    return response.data;
};

/**
 * Restablecer contraseña con token
 */
export const resetPassword = async (token: string, password: string) => {
    const response = await axiosInstance.post<{ message: string }>('/auth/reset-password', { token, password });
    return response.data;
};
